import OriginsList from './OriginsList';

export default OriginsList;
